import { useEffect } from 'react';

/**
 * Грязный хак на время эксперимента с боттом навигацией (удалить после экспа)
 * Добавляем дополнительный отступ футеру, чтобы ничего не перегораживалось таббаром
 * Сделал тут, чтобы не завозить эксперименты в футер и не добавлять кучу pageType в разные сервисы
 */
export const useFooterOffset = (isMobileBottomNavigationEnabled: boolean) => {
  useEffect(() => {
    const footer = document.getElementById('frontend-footer');

    if (footer) {
      if (isMobileBottomNavigationEnabled) {
        footer.style.setProperty('padding-bottom', '60px');
      } else if (footer.style.paddingBottom) {
        footer.style.removeProperty('padding-bottom');
      }
    }
  }, [isMobileBottomNavigationEnabled]);
};
